export const SIDE_PANEL_CONTROL_COMMANDS = {
    open: 'open',
    close: 'close',
    toggle: 'toggle',
    setSubject: 'setSubject',
    patchPayload: 'patchPayload',
    setLayout: 'setLayout'
} as const;

export const SIDE_PANEL_CLOSE_REASONS = {
    command: 'command',
    replaced: 'replaced',
    ownerUnmounted: 'ownerUnmounted',
    surfaceUnmounted: 'surfaceUnmounted'
} as const;
